import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const MerchantFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const MerchantList = props => (
    <List filters={<MerchantFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="name"/>
        </Datagrid>
    </List>
);

export default MerchantList
